var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { RULE_TYPE, KEYFRAME_TYPE, isNestedSelector, isMediaQuery, isSupport } from 'fela-utils';
import cssifyDeclaration from 'css-in-js-utils/lib/cssifyDeclaration';
import isPlainObject from 'isobject';
import { CSSLint } from 'csslint';

function handleError(property, style, logInvalid, deleteInvalid, message, logObject) {
  if (deleteInvalid) {
    delete style[property];
  }
  if (logInvalid) {
    /* eslint-disable-next-line no-console */
    console.error('' + (deleteInvalid ? '[Deleted] ' : ' ') + message, logObject);
  }
}

function validateStyleObject(style, logInvalid, deleteInvalid, useCSSLint) {
  var _loop = function _loop(property) {
    var value = style[property];

    if (isPlainObject(value)) {
      if (isNestedSelector(property) || isMediaQuery(property) || isSupport(property)) {
        validateStyleObject(value, logInvalid, deleteInvalid, useCSSLint);
      } else {
        handleError(property, style, logInvalid, deleteInvalid, 'Invalid nested property. Only use nested media queries, pseudo classes, child selectors or &-combinators.\n          Maybe you forgot to add a plugin that resolves "' + property + '".', {
          property: property,
          value: value
        });
      }
    } else {
      if (useCSSLint) {
        var _CSSLint$verify = CSSLint.verify('.fela {' + cssifyDeclaration(property, value) + ';}'),
            messages = _CSSLint$verify.messages;

        messages.forEach(function (_ref) {
          var message = _ref.message;

          handleError(property, style, logInvalid, deleteInvalid, 'Invalid property "' + property + '" with value "' + value + '". ' + message.replace(/ at line .+, col .+\./, '.'), {
            property: property,
            value: value
          });
        });
      }
    }
  };

  for (var property in style) {
    _loop(property);
  }
}

function isValidPercentage(percentage) {
  var percentageValue = parseFloat(percentage);

  return percentage.indexOf('%') !== -1 && percentageValue >= 0 && percentageValue <= 100;
}

function validateKeyframeObject(style, logInvalid, deleteInvalid, useCSSLint) {
  for (var percentage in style) {
    var _value = style[percentage];
    if (!isPlainObject(_value)) {
      handleError(percentage, style, logInvalid, deleteInvalid, 'Invalid keyframe value. An object was expected.', {
        percentage: percentage,
        style: _value
      });
      // check for invalid percentage values, it only allows from, to or 0% - 100%
    } else if (percentage !== 'from' && percentage !== 'to' && !isValidPercentage(percentage)) {
      handleError(percentage, style, logInvalid, deleteInvalid, 'Invalid keyframe property.\n        Expected either `to`, `from` or a percentage value between 0 and 100.', {
        percentage: percentage,
        style: _value
      });
    } else {
      validateStyleObject(_value, logInvalid, deleteInvalid, useCSSLint);
    }
  }
}

function validateStyle(style, type, options) {
  var logInvalid = options.logInvalid,
      deleteInvalid = options.deleteInvalid,
      useCSSLint = options.useCSSLint;


  if (type === KEYFRAME_TYPE) {
    validateKeyframeObject(style, logInvalid, deleteInvalid, useCSSLint);
  } else if (type === RULE_TYPE) {
    validateStyleObject(style, logInvalid, deleteInvalid, useCSSLint);
  }

  return style;
}

var defaultOptions = {
  logInvalid: true,
  deleteInvalid: false,
  useCSSLint: false
};

export default function validator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (style, type) {
    return validateStyle(style, type, _extends({}, defaultOptions, options));
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-validator/es/index.js
// module id = 986
// module chunks = 1